<script lang="ts">
	import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
	import { faYoutube, faStripe, faStripeS } from '@fortawesome/free-brands-svg-icons';
	import Fa from 'svelte-fa';
	import { resolveAny } from '$lib/shared/lib';
	import Section from '$lib/shared/ui/Section.svelte';
	import SectionHeading from '$lib/shared/ui/SectionHeading.svelte';
	import GradientPanel from '$lib/shared/ui/GradientPanel.svelte';
	import Reveal from '$lib/shared/ui/Reveal.svelte';
	import qrCodeImg from '$img/qr-code-colored.avif';
</script>

<Section id="howitworks">
	<Reveal class="w-full">
		<SectionHeading title="Community engagement, increased revenue" accent="increased revenue">
			Supertip promotes real-time interaction, fosters genuine connections, and nurtures a sense of
			community around your stream.
		</SectionHeading>
	</Reveal>

	<div class="mt-12 flex w-full flex-col gap-5 sm:mt-16">
		<!-- The earnings panel: the headline benefit, foregrounded. -->
		<Reveal class="w-full">
			<GradientPanel class="flex flex-col items-start gap-6 p-8 sm:p-12">
				<h3
					class="max-w-2xl text-3xl font-extrabold tracking-tight text-balance sm:text-5xl/[1.05]"
				>
					Keep up to 90% of chat revenue, paid out daily
				</h3>
				<p class="max-w-xl text-sm text-white/90 sm:text-lg">
					Supertip lets creators keep up to 90% of all chat revenue, with effortless daily payouts
					through our Stripe integration.
				</p>
				<a
					href={resolveAny('/signin')}
					class="group inline-flex items-center gap-2 rounded-full bg-white px-7 py-3 text-base font-bold text-primary-600 shadow-lg transition-transform duration-200 hover:-translate-y-0.5"
				>
					Get Started
					<span
						class="flex h-6 w-6 items-center justify-center rounded-full bg-primary-500 text-white transition-transform group-hover:translate-x-0.5"
					>
						<Fa icon={faArrowRight} size="1x" />
					</span>
				</a>
				<div class="flex items-center gap-2 text-sm font-medium text-white/80">
					<Fa icon={faStripe} class="text-2xl text-white/90" />
					Daily payouts via Stripe
				</div>
			</GradientPanel>
		</Reveal>

		<div class="grid grid-cols-1 gap-5 md:grid-cols-2">
			<!-- Connect -->
			<Reveal delay={80}>
				<div
					class="card-bg-border card-border-primary flex h-full flex-col items-start justify-center gap-6 rounded-3xl p-8"
				>
					<div class="flex items-center gap-4">
						<span
							class="text-social-youtube flex h-16 w-16 items-center justify-center rounded-2xl border border-surface-200/50 bg-surface-50 text-3xl shadow-sm dark:border-surface-700/60 dark:bg-surface-800"
						>
							<Fa icon={faYoutube} />
						</span>
						<span class="text-2xl font-bold text-surface-400">+</span>
						<span
							class="flex h-16 w-16 items-center justify-center rounded-2xl border border-surface-200/50 bg-surface-50 text-3xl text-[#635bff] shadow-sm dark:border-surface-700/60 dark:bg-surface-800"
						>
							<Fa icon={faStripeS} />
						</span>
					</div>
					<div class="flex flex-col gap-3">
						<h3 class="text-2xl font-extrabold tracking-tight text-surface-950-50 sm:text-3xl">
							Connect
						</h3>
						<p class="text-sm text-surface-800-200 sm:text-base">
							Link your YouTube and Stripe accounts in a couple of clicks. No extra software, no
							hardware.
						</p>
					</div>
				</div>
			</Reveal>

			<!-- Promote -->
			<Reveal delay={160}>
				<div
					class="card-bg-border card-border-tertiary flex h-full flex-col items-start justify-center gap-6 rounded-3xl p-8"
				>
					<div class="rounded-2xl bg-white p-3">
						<img src={qrCodeImg} class="h-28" alt="Supertip QR code" />
					</div>
					<div class="flex flex-col gap-3">
						<h3 class="text-2xl font-extrabold tracking-tight text-surface-950-50 sm:text-3xl">
							Promote
						</h3>
						<p class="text-sm text-surface-800-200 sm:text-base">
							Point your fans to a better way of supporting their favorite creator, and watch
							audience interaction climb.
						</p>
					</div>
				</div>
			</Reveal>
		</div>
	</div>
</Section>
